import {
  FETCH_OBS_SCHEDULES,
  FETCH_OBS_SCHEDULES_SUCCESS,
  FETCH_OBS_SCHEDULES_FAILURE,
  ADD_OBS_SCHEDULE,
  ADD_OBS_SCHEDULE_SUCCESS,
  ADD_OBS_SCHEDULE_FAILURE,
  EDIT_OBS_SCHEDULE,
  EDIT_OBS_SCHEDULE_SUCCESS,
  EDIT_OBS_SCHEDULE_FAILURE,
  DELETE_OBS_SCHEDULE,
  DELETE_OBS_SCHEDULE_SUCCESS,
  DELETE_OBS_SCHEDULE_FAILURE,
  TOGGLE_OBS_SCHEDULE,
  TOGGLE_OBS_SCHEDULE_SUCCESS,
  TOGGLE_OBS_SCHEDULE_FAILURE,
  FETCH_DUE_OBSERVATIONS,
  FETCH_DUE_OBSERVATIONS_SUCCESS,
  FETCH_DUE_OBSERVATIONS_FAILURE,
  FETCH_DUE_SUMMARY,
  FETCH_DUE_SUMMARY_SUCCESS,
  FETCH_DUE_SUMMARY_FAILURE,
} from "./constants";

export const fetchObsSchedules = (payload, onSuccess) => ({
  type: FETCH_OBS_SCHEDULES,
  payload,
  onSuccess,
});
export const fetchObsSchedulesSuccess = (payload) => ({
  type: FETCH_OBS_SCHEDULES_SUCCESS,
  payload,
});
export const fetchObsSchedulesFailure = () => ({
  type: FETCH_OBS_SCHEDULES_FAILURE,
});

export const addObsSchedule = (payload, onSuccess) => ({
  type: ADD_OBS_SCHEDULE,
  payload,
  onSuccess,
});
export const addObsScheduleSuccess = (payload) => ({
  type: ADD_OBS_SCHEDULE_SUCCESS,
  payload,
});
export const addObsScheduleFailure = () => ({ type: ADD_OBS_SCHEDULE_FAILURE });

export const editObsSchedule = (payload, onSuccess) => ({
  type: EDIT_OBS_SCHEDULE,
  payload,
  onSuccess,
});
export const editObsScheduleSuccess = (payload) => ({
  type: EDIT_OBS_SCHEDULE_SUCCESS,
  payload,
});
export const editObsScheduleFailure = () => ({
  type: EDIT_OBS_SCHEDULE_FAILURE,
});

export const deleteObsSchedule = (payload, onSuccess) => ({
  type: DELETE_OBS_SCHEDULE,
  payload,
  onSuccess,
});
export const deleteObsScheduleSuccess = (payload) => ({
  type: DELETE_OBS_SCHEDULE_SUCCESS,
  payload,
});
export const deleteObsScheduleFailure = () => ({
  type: DELETE_OBS_SCHEDULE_FAILURE,
});

export const toggleObsSchedule = (payload, onSuccess) => ({
  type: TOGGLE_OBS_SCHEDULE,
  payload,
  onSuccess,
});
export const toggleObsScheduleSuccess = (payload) => ({
  type: TOGGLE_OBS_SCHEDULE_SUCCESS,
  payload,
});
export const toggleObsScheduleFailure = () => ({
  type: TOGGLE_OBS_SCHEDULE_FAILURE,
});

export const fetchDueObservations = (payload, onSuccess) => ({
  type: FETCH_DUE_OBSERVATIONS,
  payload,
  onSuccess,
});
export const fetchDueObservationsSuccess = (payload) => ({
  type: FETCH_DUE_OBSERVATIONS_SUCCESS,
  payload,
});
export const fetchDueObservationsFailure = () => ({
  type: FETCH_DUE_OBSERVATIONS_FAILURE,
});

// payload: { resident_id, assessment_template_id?, skipStore? }
// skipStore=true delivers the result only via onSuccess (no redux write) — for
// scoped fetches that must not overwrite the shared resident-wide dueSummary.
export const fetchDueSummary = (payload, onSuccess) => ({
  type: FETCH_DUE_SUMMARY,
  payload,
  onSuccess,
});
export const fetchDueSummarySuccess = (payload) => ({
  type: FETCH_DUE_SUMMARY_SUCCESS,
  payload,
});
export const fetchDueSummaryFailure = () => ({
  type: FETCH_DUE_SUMMARY_FAILURE,
});
